import { useEffect } from "react";

import { BioObjectMusic } from "../../arrays/BioObjects";

function MusicAbout() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <h2>About</h2>
            <div className="musicAbout">
                {
                    Object.keys(BioObjectMusic.long).map(paragraph => {
                        return BioObjectMusic.long[paragraph];
                    })
                }
            </div>
        </>
    );
};

export default MusicAbout;